var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaegeuk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "-12 -8 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-56.3099325)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cd2e3a",
    d: "M0-12A12 12 0 0 1 0 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047a0",
    d: "M0-12A12 12 0 0 0 0 12 6 6 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -6,
    fill: "#cd2e3a",
    r: 6
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaegeuk);
export default __webpack_public_path__ + "static/media/Taegeuk.088c427ccce5f9328aa01ebf52f4da35.svg";
export { ForwardRef as ReactComponent };